import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";

const useSiteConfig = () => {
  const { siteConfig } = useAppContext();
  return siteConfig;
};

export default useSiteConfig;
